export default __webpack_public_path__ + "static/media/heart-orange.dcb31c07.svg";